

































































import Vue from 'vue'
import Component from 'vue-class-component'
import { JobSearchModule } from '@app/componentlib/src/store/modules/jobSearch'
import { IFilterItem, ISearchParams, ISearchFilters, IDateItem } from '@app/componentlib/common/types/JobSearchTypes'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import SearchFiltersMobile from './SearchFilters/SearchFiltersMobile.vue'
import SearchFilterRadioButtons from './SearchFilters/SearchFilterRadioButtons.vue'
import SearchFilterDropdown from './SearchFilters/SearchFilterDropdown.vue'

@Component<JobSearchFilters>({
  components: {
    SearchFiltersMobile,
    SearchFilterRadioButtons,
    SearchFilterDropdown
  },
  props: {
    filterIsActive: Boolean,
    showRadioButtons: Boolean,
    dateStartSearch: Boolean,
    filtersToExclude: Array
  },
  watch: {
    filtersToExclude(value) {
      if(value.includes('jobCategories')) {
        this.searchParams.JobCategoryFilter = [];
      }
      if(value.includes('careers')) {
        this.searchParams.CareerFilter = [];
      }
      if(value.includes('industries')) {
        this.searchParams.IndustryFilter = [];
      }
    }
  }
})

export default class JobSearchFilters extends Vue {
  /**
   * Props variables
   */
  filterIsActive!: boolean
  showRadioButtons: boolean = false
  dateStartSearch: boolean = false
  filtersToExclude: String[] = []

  /**
   * Component state variables
   */
  activeFilter: IFilterItem[] = []
  activeChosenFilter: string = ""
  dates = JobSearchModule.dates
  jobCategories: IFilterItem[] = this.sortArrayAlphabetically(this.searchFilters?.JobCategoryFilters!)
  careers: IFilterItem[] = this.sortCareerArray(this.searchFilters?.CareerFilters!)
  industries: IFilterItem[] = this.sortArrayAlphabetically(this.searchFilters?.IndustryFilters!)

  /**
   * Lifecycle
   */


  /**
   * Getters
   */
  get t (): any {
    return AppModule.translations
  }

  get searchParams (): ISearchParams {
    return JobSearchModule.searchParams
  }

  get searchFilters (): ISearchFilters | undefined {
    return JobSearchModule.searchFilters
  }

  get chosenJobCategories (): string[] {
    return this.searchParams.JobCategoryFilter
  }

  get chosenCareers (): string[] {
    return this.searchParams.CareerFilter
  }

  get chosenIndustries (): string[] {
    return this.searchParams.IndustryFilter
  }

  get startDate (): IDateItem | undefined {
    for (let item in this.dates) {
      if (this.dates[item].Date === this.searchParams.StartDate?.toString())
        return this.dates[item]
    }

    return undefined
  }

  get isMobile (): boolean {
    return AppModule.isMobile
  }

  /**
   * Methods
   */

  // Adding a filter item from a given array into the search params
  clickedItemFilter(param: {arrayToPushTo: string, item: string}) {
    let params = this.searchParams

    switch (param.arrayToPushTo) {
      case 'jobs':
        params.JobCategoryFilter = this.AddOrRemoveItemFromList(param.item, this.chosenJobCategories, params.JobCategoryFilter)
        break
      case 'careers':
        params.CareerFilter = this.AddOrRemoveItemFromList(param.item, this.chosenCareers, params.CareerFilter)
        break
      case 'industries':
        params.IndustryFilter = this.AddOrRemoveItemFromList(param.item, this.chosenIndustries, params.IndustryFilter)
        break
    }

    JobSearchModule.setSearchParams(params)
  }

  // Either removes or adds a filter item depending on, if it already exists in chosenArray
  AddOrRemoveItemFromList(item: string, chosenArray: string[], paramsArray: string[]) {
    if(item === 'removeAll')
      paramsArray = []
    else {
      let itemsExists = chosenArray.find((obj: any) => item === obj)

      if (!itemsExists)
        paramsArray.push(item)
      else
        paramsArray = paramsArray.filter((obj: any) => obj !== item)
    }

    return paramsArray
  }

  // Update date when item is clicked
  dateClicked(item: IDateItem) {
    let params = this.searchParams
    params.StartDate = new Date(item.Date)
    params.StartDateString = item.Id.toString()
    JobSearchModule.setSearchParams(params)
    if (this.dateStartSearch)
      this.startSearch()
  }

  startSearch() {
    this.activeFilter = []
    this.activeChosenFilter = ''

    document.documentElement.style.overflow = 'scroll'
    this.changeShowOverlay(false)
    this.$emit('startSearch', false)
  }

  changeShowOverlay(e: any) {
    this.$emit('changeShowOverlay', e.type === "show" ? true : false)
  }

  // Change active filter is used on mobile, to display a chosen filter list
  changeActiveFilter(param: {item: any, chosenFilter: string}) {
    this.activeFilter = param.item
    this.activeChosenFilter = param.chosenFilter

    if (param.item.length > 0) {
      document.documentElement.style.background = 'white'
    } else {
      document.documentElement.style.background = 'none'
    }
  }

  changeMobileFiltersIsOpen(bool: boolean) {
    this.$emit('changeMobileFiltersIsOpen', bool)
  }

  // Sort career array, it need to be in a specific order, determined by PO.
  sortCareerArray(array: IFilterItem[]): IFilterItem[] {
    const sortList: string[] = [ '1', '2', '3', '4', '10', '11', '12', '6', '5', '9', '7', '8', '0']
    const sortedObj: IFilterItem[] = array.sort((a, b) => {
      return(
        sortList.indexOf(a.Id) - sortList.indexOf(b.Id)
      )
    })

    return sortedObj
  }

  // Sort array aplabetically
  sortArrayAlphabetically(array: IFilterItem[]): IFilterItem[] {
    if (array.length > 0 && array !== undefined) {
      let temp = []
      temp = array.filter(a => a.Name)

      return temp.sort(function(a,b) {
         return a.Name.localeCompare(b.Name)
      })
    }
    else
      return []
  }
}
